import React from 'react';

const CreditsCharge = () => {
  return <h1>CreditsCharge Page</h1>;
};

export default CreditsCharge;
